import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import axiosInstance from "./axiosInstance";

export default function UnavailablePage() {
  const [search] = useSearchParams();
  const prev_route = search.get("prev_route") || "/";

  useEffect(() => {
    const id = setInterval(checkHealth, 20_000);          // 20s
    return () => clearInterval(id);
  }, []);

  async function checkHealth() {
    try {
      await axiosInstance.get("/health", { params: { t: Date.now() } });
      window.location.assign(prev_route);                        // service restored
    } catch {
      /* still down */
    }
  }

  const container = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--background-color)",
    color: "var(--text-color)",
    fontFamily: "inherit",
    padding: 24,
    textAlign: "center",
  };

  const card = {
    background: "var(--card-background-color)",
    borderRadius: "var(--border-radius)",
    boxShadow: "var(--box-shadow)",
    maxWidth: 420,
    width: "100%",
    padding: "48px 32px",
  };

  const heading = { margin: "0 0 12px", fontSize: 28, fontWeight: 600 };
  const body = { margin: 0, fontSize: 16, lineHeight: 1.5 };

  const spinner = {
    width: 36,
    height: 36,
    border: "4px solid var(--accent-color)",
    borderTopColor: "var(--primary-color)",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "24px auto 0",
  };

  return (
    <div style={container}>
      <div style={card}>
        <h1 style={heading}>Service Temporarily Unavailable</h1>
        <p style={body}>You will be redirected automatically when service resumes.</p>
        <div style={spinner} />
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}